import * as localforage from 'localforage';

export const writeData = localforage.setItem.bind(null);

export const readData = localforage.getItem.bind(null);



// WEBPACK FOOTER //
// ./src/services/StorageService.ts